export default __webpack_public_path__ + "src/assets/telegram.81221e10fb2ad8f0e0bc3f1024c2ce51.svg";